module.exports = "/images/img_tshirt_4.png?d068926c75ac9096f8de2a6607f9d1fb";